export const iceChoice = [
    {
        id: "1",
        name: "正常冰",
    },
    {
        id: "2",
        name: "少冰",
    },
    {
        id: "3",
        name: "去冰",
    },
    {
        id: "4",
        name: "常溫",
    },
    {
        id: "5",
        name: "熱",
    },
];
export const sugarChoice = [
    { id: "1", name: "無糖" },
    { id: "2", name: "微糖" },
    { id: "3", name: "半糖" },
    { id: "4", name: "全糖" },
];
